export default __webpack_public_path__ + "locales/fr/Settings.json?hash=7eea963b1e173bc98b4b4e5507b537e7";